import { createEntityQueryKeys } from '@/shared/lib'

export const apiAccessKeys = createEntityQueryKeys(['api-access'])
